import {ERROR_BACKGROUND, ERROR_COLOR} from "../../../../themes/themeConfigurator";

const styles = (theme) => ({
  dialogTitle: {
    background: ERROR_BACKGROUND,
    '& .fa-exclamation-triangle': {
      color: ERROR_COLOR,
      marginRight: theme.spacing(1)
    }
  },
  dialogContent: {
    paddingTop: theme.spacing(4),
    paddingBottom: theme.spacing(4),
  }
});

export default styles;